package com.mgacreative.hotelru.domain.di

import com.mgacreative.hotelru.domain.repository.*
import org.koin.dsl.module

fun getDomainModule() = module {
    single { ReservationRepository(get(), getOrNull()) }
    single { RoomRepository(get(), getOrNull()) }
    single { PricingRepository(get()) }
    single { GuestRepository(get()) }
    single { ShiftRepository(get(), get()) }
    single { StaffRepository(get(), get()) }
    single<FinanceRepository> { FinanceRepositoryImpl(get(), get()) }
    single<PosRepository> { PosRepositoryImpl(get(), get(), get()) }
    single<InventoryRepository> { InventoryRepositoryImpl(get(), get()) }
    single<PurchasingRepository> { PurchasingRepositoryImpl(get(), get(), get()) }
    single<SupplierRepository> { SupplierRepositoryImpl(get()) }
    single<AgencyRepository> { AgencyRepositoryImpl(get()) }
    single<DepartmentRepository> { DepartmentRepositoryImpl(get(), get()) }
    single<BlacklistRepository> { BlacklistRepositoryImpl(get()) }
}

